export const ROLES_LIMIT = 5;
export const FILTERS_LIMIT = 5;

export const PARSE_JSON_DEBOUNCE_TIMEOUT = 500;
